import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, Text, useWindowDimensions, View } from 'react-native';
import { Input } from './Input';
import { Divider } from './Divider';
import { applyTransparency } from '../../constants/colors';
import { PopupV2 } from './PopupV2';
import ButtonGeneral from './ButtonGeneral';

interface IPopupProps {
  visible: boolean;
  firstName: string;
  lastName: string;
  password?: string;
  userName: string;
  loading: boolean;

  setVisible: (value: boolean) => void;
  onSavePress: (firstName: string, lastName: string, userName: string, password: string) => void;
}
const EditPopup = ({
  visible,
  setVisible,
  onSavePress,
  firstName,
  lastName,
  userName,
  password,
  loading,
}: IPopupProps) => {
  const [innerFirstName, setInnerFirstName] = useState('');
  const [innerLastName, setInnerLastName] = useState('');
  const [innerUserName, setInnerUserName] = useState('');
  const [innerPassword, setInnerPassword] = useState('');
  const { width } = useWindowDimensions();
  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  const isMobile = isMobileWeb || Platform.OS !== 'web';

  useEffect(() => {
    setInnerFirstName(firstName);
    setInnerLastName(lastName);
    setInnerUserName(userName);
    setInnerPassword(password ? password : '');
  }, [firstName, lastName, userName, password]);

  return (
    <PopupV2
      height={isMobile ? 570 : 'auto'}
      title="Edit Student Information"
      visible={visible}
      setVisible={setVisible}
      closeOnBackdropPress={true}
      containerStyle={{
        backgroundColor: '#FCEABB',
        borderColor: '#FFCF53',
        width: isMobile ? 348 : 700,
        maxWidth: 1000,
        padding: 0,
      }}
      headerTextStyle={{ fontSize: isMobile ? 18 : 24 }}
      hideCloseButton={true}
    >
      <View style={styles.container}>
        <Divider empty height={20} />
        <Divider empty height={24} />
        <View style={[styles.entryRow, isMobile && { flexDirection: 'column' }]}>
          <View style={{ marginBottom: isMobile ? 16 : 0 }}>
            <Text style={styles.label}>First name</Text>
            <Input
              style={{ width: isMobile ? 304 : 320 }}
              placeholder="First Name"
              value={innerFirstName}
              setValue={value => setInnerFirstName(value)}
              textStyle={{ fontSize: 14, textAlign: 'left', marginLeft: 10 }}
            />
          </View>
          <View style={{ marginBottom: isMobile ? 16 : 0 }}>
            <Text style={styles.label}>Last name</Text>
            <Input
              style={{ width: isMobile ? 304 : 320 }}
              placeholder="Last Name"
              value={innerLastName}
              setValue={value => setInnerLastName(value)}
              textStyle={{ fontSize: 14, textAlign: 'left', marginLeft: 10 }}
            />
          </View>
        </View>
        {!isMobile && <Divider empty height={32} />}
        <View style={[styles.entryRow, isMobile && { flexDirection: 'column' }]}>
          <View style={{ marginBottom: isMobile ? 16 : 0 }}>
            <Text style={styles.label}>User Name</Text>
            <Input
              style={{ width: isMobile ? 304 : 320 }}
              placeholder="User Name"
              value={innerUserName}
              setValue={value => setInnerUserName(value)}
              textStyle={{ fontSize: 14, textAlign: 'left', marginLeft: 10 }}
            />
          </View>
          <View>
            <Text style={styles.label}>Password</Text>
            <Input
              style={{ width: isMobile ? 304 : 320 }}
              placeholder="Password"
              value={innerPassword}
              setValue={value => setInnerPassword(value)}
              textStyle={{ fontSize: 14, textAlign: 'left', marginLeft: 10 }}
            />
          </View>
        </View>

        <Divider empty height={32} />
        {/* <MenuButton
          height={62}
          width={320}
          onPress={() => onSavePress(innerFirstName, innerLastName)}
          text="Save changes"
          colors={['#90DF75', '#62B655']}
          textStyle={styles.buttonTextStyle}
          loading={loading}
          disabled={loading}
        /> */}
        <View style={[styles.buttonContainer, { height: isMobile ? 80 : 102 }]}>
          <View style={{ marginRight: isMobile ? 8 : 12 }}>
            <ButtonGeneral
              onPress={() => {
                setVisible(false);
              }}
              title={'Cancel'}
              height={isMobile ? 48 : 58}
              width={isMobile ? 151 : 201}
              fontSize={isMobile ? 14 : 16}
              fontStyle={{ color: '#000000' }}
              colors={['#FEDD88', '#FEDD88']}
              nameContainerStyle={{
                borderColor: '#ffffff',
                borderWidth: 2,
                marginRight: isMobile ? 10 : 0,
              }}
            />
          </View>
          <ButtonGeneral
            onPress={() => onSavePress(innerFirstName, innerLastName, innerUserName, innerPassword)}
            title={`Save${isMobile ? '' : ' changes'}`}
            height={isMobile ? 48 : 58}
            width={isMobile ? 151 : 201}
            fontSize={isMobile ? 14 : 16}
            fontStyle={{ color: '#000000' }}
            colors={['#FFCF53', '#FF9900']}
          />
        </View>
      </View>
    </PopupV2>
  );
};

export { EditPopup };

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Secular One',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#121212',
    fontSize: 18,
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  buttonTextStyle: {
    fontFamily: 'Secular One',
    color: '#ffffff',
    fontSize: 20,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
  },
  label: {
    fontFamily: 'Secular One',
    marginBottom: 8,
    fontSize: 14,
  },
  entryRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingHorizontal: 20,
  },
  buttonContainer: {
    justifyContent: 'center',
    backgroundColor: '#FEDD88',
    alignItems: 'center',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    flexDirection: 'row',
    width: '100%',
    marginTop: 0,
  },
});
